import React from 'react'
import TagManager from 'react-gtm-module'
import {Box, Flex, Text} from '../../utils/chakraMonomorphic'

import {PageHeader} from '../../components/PageHeader/PageHeader'
import {useCreateTrackingLink} from '../../services/useCreateTrackingLink'
import {PageTemplate} from '../../templates/PageTemplate/PageTemplate'

import copy from './copy.json'
import {TextDisplayWithClipboardCopy} from '../../components'

export const RegistrationLinkView: React.FC<React.PropsWithChildren> = () => {
  const {
    trackingLink,
    getTrackingLink,
    status: trackingLinkStatus,
  } = useCreateTrackingLink()

  React.useEffect(() => {
    if (trackingLinkStatus !== 'failure' && !trackingLink) {
      getTrackingLink('registration')
    }
  }, [trackingLinkStatus, trackingLink, getTrackingLink])

  const pageHeader = (
    <PageHeader
      title={copy.title}
      logContext='RegistrationLink'
      description={copy.description}
    />
  )

  return (
    <PageTemplate
      header={pageHeader}
      width={['100%']}
      maxWidth={['1030px']}
      borderX={['0px']}>
      <Flex direction='column' px='.75em'>
        <Box borderTop='1px' mt={3} mb={12} />
        <TextDisplayWithClipboardCopy
          text={trackingLink}
          placeholder={
            trackingLinkStatus === 'failure'
              ? 'Failed to generate your link.'
              : 'Fetching your link...'
          }
          onAfterCopy={(copyText): void => {
            TagManager.dataLayer({
              dataLayer: {
                event: 'copy_dynamic_link',
                dynamicLinkType: 'registration',
                dynamicLinkURL: copyText,
              },
            })
          }}
        />
        <Flex direction='column' maxW='650px' pt='10px'>
          <Text fontSize='1.1rem' fontWeight='bold'>
            {copy.explanation.title}
          </Text>
          <Text mb='20px'>{copy.explanation.body1}</Text>
          <Text>{copy.explanation.body2}</Text>
        </Flex>
      </Flex>
    </PageTemplate>
  )
}
